import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { boxoMiniAppIds, BoxoBannersEnumID } from '@/constants/boxoMiniAppIds'
import { EsimBannerBg } from '@/assets/images/backgrounds'

export interface BoxoBannerItem {
  id: BoxoBannersEnumID
  title: string
  description: string
  backgroundImage: string
  isVisible: boolean
  onPress: () => void
}

export const useBoxoBannersList = (): BoxoBannerItem[] => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleOpenMiniapp = (appId: string) => {
    if (appId) {
      navigate(`/boxo-miniapp/${appId}`)
    }
  }

  return [
    {
      id: BoxoBannersEnumID.travelESIMs,
      title: t('banners:boxo.travelESIMs.title'),
      description: t('banners:boxo.travelESIMs.description'),
      backgroundImage: EsimBannerBg,
      isVisible: !!boxoMiniAppIds.travelESIMs,
      onPress: () => handleOpenMiniapp(boxoMiniAppIds.travelESIMs),
    },
    {
      id: BoxoBannersEnumID.airportLounges,
      title: t('banners:boxo.airportLounges.title'),
      description: t('banners:boxo.airportLounges.description'),
      backgroundImage: '/assets/images/homeBanners/boxo-banner-bg.png',
      isVisible: !!boxoMiniAppIds.airportLounges,
      onPress: () => handleOpenMiniapp(boxoMiniAppIds.airportLounges),
    },
    {
      id: BoxoBannersEnumID.hotels,
      title: t('banners:boxo.hotels.title'),
      description: t('banners:boxo.hotels.description'),
      backgroundImage: '/assets/images/homeBanners/boxo-banner-bg.png',
      isVisible: !!boxoMiniAppIds.hotels,
      onPress: () => handleOpenMiniapp(boxoMiniAppIds.hotels),
    },
    {
      id: BoxoBannersEnumID.flights,
      title: t('banners:boxo.flights.title'),
      description: t('banners:boxo.flights.description'),
      backgroundImage: '/assets/images/homeBanners/boxo-banner-bg.png',
      isVisible: !!boxoMiniAppIds.flights,
      onPress: () => handleOpenMiniapp(boxoMiniAppIds.flights),
    },
  ]
}
